// Face check-in strings live with the attendance page translations
// ((User)attendance_page/constant/translations.js → `face`), in Arabic and
// English. This helper hands them to the profile and admin pages too.
import { translations } from "../../pages/(User)attendance_page/constant/translations";

export const faceText = (language) => (translations[language] || translations.en).face;

/** "Photo {n} of 3" → "Photo 2 of 3" */
export const fill = (template, vars = {}) =>
  String(template || "").replace(/\{(\w+)\}/g, (_, k) => (vars[k] === undefined ? `{${k}}` : String(vars[k])));

/**
 * The message to show for a FaceApiError: our translation of its code, and
 * the server's own message verbatim when it differs (the server may say more,
 * e.g. which frame failed).
 */
export const describeFaceError = (err, language) => {
  const t = faceText(language);
  const code = err?.code || null;
  const translated = code ? t.codes[code] : null;
  const server = err?.body?.messages?.[language] || err?.body?.message || err?.message || null;
  const isApiError = err && (err.name === "FaceApiError" || err.status);
  if (!isApiError) return { title: t.failedTitle, message: translated || t.genericError, code, server: null };
  const message = translated || server || t.genericError;
  const serverExtra = server && server !== message && !/^Request failed/.test(server) ? server : null;
  return { title: t.refusedTitle, message, code, server: serverExtra };
};

/** "Move closer" / "Move back" hint from the error code or the face box size. */
export const distanceHint = (err, language) => {
  const t = faceText(language);
  if (!err) return null;
  if (err.code === "face_too_small") return t.moveCloser;
  const box = err.faceBox;
  if (box && Number.isFinite(box.width) && Number.isFinite(box.frameWidth)) {
    const ratio = box.width / box.frameWidth;
    if (ratio < 0.2) return t.moveCloser;
    if (ratio > 0.7) return t.moveBack;
  }
  return null;
};
